import React from "react"
import Slider from "react-slick"

import t from "../locale"

const OfficesSliderTowerLower = ({ lang }) => {
  const officesSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    fade: true,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          arrows: false,
        },
      },
    ],
  }

  return (
    <Slider {...officesSlider}>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>
                {t("4 tenants", lang)} {t("(floor 3-7)", lang)}
              </h4>
              <p>
                1082,5{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p></p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/Unity_Tower_lower_floor/Unity_Tower_lower_floor_4Tenants_v2.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom offices-schema__wrapper-bottom--one-col">
            <ul>
              <li>
                {t("Tenant", lang)} 01 – 16 {t("workplaces", lang)}
              </li>
              <li>
                {t("Tenant", lang)} 02 – 27 {t("workplaces", lang)}
              </li>
              <li>
                {t("Tenant", lang)} 03 – 15 {t("workplaces", lang)}
              </li>
              <li>
                {t("Tenant", lang)} 04 – 15 {t("workplaces", lang)}
              </li>
            </ul>
            <a
              href={
                lang === "en"
                  ? require("../assets/pdf/UNITY-Tower-lower-floor-4-tenants_v2-en.pdf")
                  : require("../assets/pdf/UNITY-Tower-lower-floor-4-tenants_v2.pdf")
              }
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>
                {t("Modern version", lang)} {t("(floor 3-7)", lang)}
              </h4>
              <p>
                1082,5{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>55 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/Unity_Tower_lower_floor/Unity_Tower_lower_floor_modern_v2.png")}
              alt=""
              height="50%"
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("3 office rooms / 1 person", lang)}</li>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("6 conference rooms", lang)}</li>
              <li>{t("Kitchen", lang)}</li>
              <li>{t("Relax and lounge area", lang)}</li>
              <li>{t("4 storage rooms", lang)}</li>
            </ul>
            <a
              href={
                lang === "en"
                  ? require("../assets/pdf/UNITY-Tower-lower-floor-modern_v2-en.pdf")
                  : require("../assets/pdf/UNITY-Tower-lower-floor-modern_v2.pdf")
              }
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>
                {t("Traditional version", lang)} {t("(floor 3-7)", lang)}
              </h4>
              <p>
                1082,5{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>114 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/Unity_Tower_lower_floor/Unity_Tower_lower_floor_traditional_v2.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("2 office rooms / 1 person", lang)}</li>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("6 conference rooms", lang)}</li>
              <li>{t("Kitchen", lang)}</li>
              <li>{t("2 storage rooms", lang)}</li>
              <li>{t("Relax area", lang)}</li>
            </ul>
            <a
              href={
                lang === "en"
                  ? require("../assets/pdf/UNITY-Tower-lower-floor-traditional_v2-en.pdf")
                  : require("../assets/pdf/UNITY-Tower-lower-floor-traditional_v2.pdf")
              }
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      {/* <div>
        {lang === "en" ? (
          <img
            className="img-fluid"
            src={require("../assets/images/offices-UTower-bottom-en.jpg")}
            alt=""
          />
        ) : (
          <img
            className="img-fluid"
            src={require("../assets/images/offices-UTower-bottom-pl.jpg")}
            alt=""
          />
        )}
      </div> */}
    </Slider>
  )
}

export default OfficesSliderTowerLower
